// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"PZ-z","subtitle":"QZ-z","wrapper":"RZ-z","leftArrow":"SZ-z","rightArrow":"TZ-z"};